module.exports = __webpack_public_path__ + "img/check.86cc5afd.svg";